// 应用基础信息
export const APP_NAME = '超级产品经理';
export const APP_SLOGAN = '产品经理AI工作平台';
export const APP_TAGLINE = '产品经理AI工作平台';
export const APP_VERSION = '1.2.3';

// 品牌资源
export const LOGO_URL = '/logo.png';
export const LOGO_ALT = 'Logo';

// 产品教练相关
export const COACH_NAME = '产品教练';
export const COACH_NAME_WITH_PREFIX = '产品教练';
export const COACH_LOGIN_TITLE = '产品教练登录';
export const COACH_BIND_TITLE = '绑定产品教练账号';
export const COACH_UNBIND_TITLE = '确认解绑';
export const COACH_UNBIND_CONTENT = '解绑后将失去产品教练身份，确定要继续吗？';

// 法律文档
export const PRIVACY_POLICY_TITLE = '隐私政策';
export const TERMS_OF_SERVICE_TITLE = '用户服务协议';
export const PRIVACY_POLICY_FILE = '/privacy-policy.md';
export const TERMS_OF_SERVICE_FILE = '/terms-of-service.md';

// 通用按钮文本
export const BUTTON_TEXT = {
  LOGIN: '登录',
  REGISTER: '注册',
  LOGOUT: '退出登录',
  CONFIRM: '确认',
  CANCEL: '取消',
  SAVE: '保存',
  DELETE: '删除',
  EDIT: '编辑',
  SEND: '发送验证码',
  UPLOAD: '上传',
  BIND: '绑定',
  UNBIND: '解绑',
  NEW_CHAT: '新建对话',
} as const;

// 通用提示文本
export const MESSAGE_TEXT = {
  LOGIN_SUCCESS: '登录成功',
  LOGIN_FAILED: '登录失败',
  REGISTER_SUCCESS: '注册成功',
  REGISTER_FAILED: '注册失败',
  LOGOUT_SUCCESS: '已退出登录',
  SAVE_SUCCESS: '保存成功',
  DELETE_SUCCESS: '删除成功',
  SEND_CODE_SUCCESS: '验证码已发送，请查看邮箱',
  SEND_CODE_FAILED: '发送验证码失败',
  RESET_PASSWORD_SUCCESS: '密码已重置，请使用新密码登录',
} as const;

// 表单占位符
export const PLACEHOLDER_TEXT = {
  USERNAME: '用户名',
  PASSWORD: '密码',
  EMAIL: '邮箱',
  VERIFICATION_CODE: '请输入验证码',
  DISPLAY_NAME: '显示名称（可选）',
  SEND_MESSAGE: (name: string) => `给「${name}」发送消息`,
  COACH_USERNAME: '产品教练用户名',
  COACH_PASSWORD: '产品教练密码',
} as const;

// 页面标题
export const PAGE_TITLES = {
  LOGIN: '登录',
  REGISTER: '注册账号',
  SETUP: '初始化',
  FORGOT_PASSWORD: '忘记密码',
  RESET_PASSWORD: '重置密码',
} as const;

// 确认对话框
export const CONFIRM_DIALOG = {
  LOGOUT_TITLE: '确认退出登录？',
  LOGOUT_CONTENT: '退出后需要重新登录才能使用',
  DELETE_CONVERSATION_TITLE: '删除对话',
  DELETE_CONVERSATION_CONTENT: '确定要删除这个对话吗？',
} as const;

// 初始化页面
export const SETUP_TEXT = {
  SUBTITLE: '2 步快速开始，约 30 秒完成（全部可跳过）',
  SKIP_TIP: '💡 所有字段均可跳过，数据会自动保存到云端',
} as const;

// 设置页面
export const SETTINGS_TEXT = {
  ABOUT_TITLE: (name: string) => `${name} - 产品经理AI工作平台`,
  STORAGE_LIMIT_TIP: '默认 10MB 存储空间，上传参考图和文档都会占用存储空间。',
  DELETE_ACCOUNT_WARNING: '警告：注销账号将永久删除您的所有数据，包括生成的图片、文件、积分记录等，此操作不可恢复！',
} as const;
